import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsIconModule } from '@components/icon';
import { DiscontinuedPopupComponent } from './discontinued-popup.component';
import { DiscontinuedInfoPopupComponent } from './discontinued-info-popup.component';

@NgModule({
  imports: [CommonModule, CsIconModule],
  declarations: [DiscontinuedPopupComponent, DiscontinuedInfoPopupComponent],
  exports: [DiscontinuedPopupComponent, DiscontinuedInfoPopupComponent],
})
export class DiscontinuedPopupModule {}
